import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const STERISUL_LOGO = "/sterisul-logo.png";

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isRegister, setIsRegister] = useState(false);
  const [name, setName] = useState('');
  const [role, setRole] = useState('tecnico');
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      if (isRegister) {
        await register({ email, password, name, role });
        toast.success('Conta criada com sucesso! Faça login.');
        setIsRegister(false);
      } else {
        await login(email, password);
        toast.success('Login realizado com sucesso!');
        navigate('/dashboard');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao processar requisição');
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left side - Form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-slate-50">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <img 
              src={STERISUL_LOGO} 
              alt="Sterisul - Centro de Esterilização" 
              className="w-32 h-32 mx-auto mb-4 object-contain"
            />
            <p className="text-lg text-slate-600 mt-2">
              Centro de Esterilização
            </p>
          </div>

          <div className="bg-white border border-slate-200 rounded-lg p-8 shadow-sm">
            <form onSubmit={handleSubmit} className="space-y-4">
              {isRegister && (
                <>
                  <div>
                    <Label htmlFor="name">Nome Completo</Label>
                    <Input
                      data-testid="input-name"
                      id="name"
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                      className="mt-1"
                    />
                  </div>
                  <div>
                    <Label htmlFor="role">Perfil</Label>
                    <select
                      data-testid="select-role"
                      id="role"
                      value={role}
                      onChange={(e) => setRole(e.target.value)}
                      className="mt-1 w-full px-3 py-2 border border-slate-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="admin">Administrador</option>
                      <option value="tecnico">Técnico CME</option>
                      <option value="enfermeiro">Enfermeiro</option>
                      <option value="responsavel">Responsável Técnico</option>
                      <option value="auditor">Auditor</option>
                    </select>
                  </div>
                </>
              )}
              
              <div>
                <Label htmlFor="email">Email</Label>
                <Input
                  data-testid="input-email"
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="mt-1"
                />
              </div>

              <div>
                <Label htmlFor="password">Senha</Label>
                <Input
                  data-testid="input-password"
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="mt-1"
                />
              </div>

              <Button
                data-testid="btn-submit"
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white"
              >
                {isRegister ? 'Criar Conta' : 'Entrar'}
              </Button>
            </form>

            <div className="mt-4 text-center">
              <button
                data-testid="btn-toggle-mode"
                type="button"
                onClick={() => setIsRegister(!isRegister)}
                className="text-sm text-blue-600 hover:text-blue-700"
              >
                {isRegister ? 'Já tem conta? Entrar' : 'Criar nova conta'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - Logo grande */}
      <div className="hidden lg:flex flex-1 relative bg-gradient-to-br from-blue-600 to-blue-800 items-center justify-center">
        <div className="text-center p-12">
          <img 
            src={STERISUL_LOGO} 
            alt="Sterisul" 
            className="w-80 h-80 mx-auto object-contain drop-shadow-2xl"
          />
          <h2 className="text-3xl font-bold text-white mt-8">Sterisul</h2>
          <p className="text-xl text-blue-100 mt-2">Centro de Esterilização</p>
          <p className="text-blue-200 mt-4 max-w-md mx-auto">
            Sistema completo para gestão de esterilização conforme ANVISA/RDC 15
          </p>
        </div>
      </div>
    </div>
  );
}